// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useHistory } from "react-router-dom";
import { getStorage } from "firebase/storage";
import { useEffect, useState } from "react";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { updateProfile } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { ToastContainer, toast } from "react-toastify";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyALnpV7ZZ9sIwaRTegVnO3C7qiuU_0Ri5g",
  authDomain: "blenny-e992b.firebaseapp.com",
  projectId: "blenny-e992b",
  storageBucket: "blenny-e992b.appspot.com",
  messagingSenderId: "641969553276",
  appId: "1:641969553276:web:4199f6413425976ec72ef9",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const db = getDatabase(app);
const firestoredb = getFirestore(app);
// const currentUsera = "";

export const useAuth = () => {
  const [currentUser, setCurrentUser] = useState();
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => setCurrentUser(user));
    return unsub;
  }, []);
  return currentUser;
};

export { auth, app, storage, db, firestoredb };
